import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button, Modal, ModalBody, ModalFooter, Input } from 'reactstrap';
import Icon from '@material-ui/core/Icon';
import ReactDatePicker from "react-datepicker";
import InputFeild from "../../global/form/input";
import SelectList from "../../global/form/select";
import { setError, setLoader } from "../../../actions/action-creators";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import moment from "moment";
import ConfirmAction from "../../global/confirm-action";

const ORIGIN_TYPE_OPTIONS = [
    { value: "JOB_CATEGORY",     label: "Job Category" },
    { value: "JOB_TASK",         label: "Job Task" },
    { value: "HOME_LEADERBOARD", label: "Home Leaderboard" },
    { value: "REFERRAL",         label: "Referral" },
    { value: "RECHARGE",         label: "Recharge" },
];

function isValidUrl(str) {
    try { return Boolean(new URL(str)); } catch { return false; }
}


const LABEL = {
    fontSize: 11, fontWeight: 700, letterSpacing: "0.6px",
    textTransform: "uppercase", color: "#666", marginBottom: 6, display: "block",
};

class CreateBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCreateBanner: false,
            bannerList: [],
            jobCategoryList: [],
            showExpired: false,
            previewImageUrl: null,
            isOpenConfirm: false,
            bannerFile: null,
            bannerPreviewUrl: null,
            draggedBannerIndex: null,
        };
    }

    handleDragInput = (e) => { this.setState({ draggedBannerIndex: e.currentTarget.id }); }

    handleDropInput = async (e) => {
        let { draggedBannerIndex } = this.state;
        let droppedBannerIndex = e.currentTarget.id;
        if (!draggedBannerIndex || !droppedBannerIndex) return;
        let banners = [...this.state.bannerList];
        let draggedBanner = banners.splice(draggedBannerIndex, 1);
        if (!draggedBanner[0]) return;
        banners.splice(droppedBannerIndex, 0, draggedBanner[0]);
        banners = banners.map((b, i) => { b.seq_no = i + 1; return b; });
        let updateData = banners
            .filter((_, i) => draggedBannerIndex > droppedBannerIndex ? i >= droppedBannerIndex : i >= draggedBannerIndex && i <= droppedBannerIndex)
            .map(b => ({ promotion_id: b.promotion_id, seq_no: b.seq_no }));
        await Promise.all(updateData.map(b => ApiEndpoints.Marketing.updateBanner(b)));
        this.setState({ bannerList: [...banners] });
    }

    componentDidMount() {
        this.fetchBannerList();
        this.fetchJobCategories();
    }

    fetchJobCategories = async () => {
        try {
            let resp = await ApiEndpoints.Jobs.fetchCategory();
            this.setState({ jobCategoryList: resp.data.data });
        } catch (e) { /* non-critical, fail silently */ }
    }

    fetchBannerList = async () => {
        store.dispatch(setLoader(true));
        try {
            let apiData = await ApiEndpoints.Marketing.fetchBanners();
            this.setState({ bannerList: apiData.data.data });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    }

    delete = async (promotion_id) => {
        store.dispatch(setLoader(true));
        try {
            await ApiEndpoints.Marketing.deleteBanner({ promotion_id });
            await this.fetchBannerList();
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    }

    openModal  = () => this.setState({ isCreateBanner: { actionType: "SCREEN" }, bannerFile: null, bannerPreviewUrl: null });
    closeModal = () => this.setState({ isCreateBanner: false, bannerFile: null, bannerPreviewUrl: null });

    buildActionJSON = () => {
        let f = this.state.isCreateBanner;
        if (f.actionType === "LINK") return JSON.stringify({ type: "LINK", value: f.link_url || "" });
        let obj = { type: "SCREEN", origin_type: f.origin_type || "" };
        if (f.origin_id) obj.origin_id = Number(f.origin_id);
        return JSON.stringify(obj);
    }

    createBanner = async (e) => {
        e.preventDefault();
        let { isCreateBanner } = this.state;
        let file = this.state.bannerFile;
        let fileName = "promotions/banner/" + new Date().getTime() + "_" + file.name;
        let fileResp = await ApiEndpoints.Files.filePublicPutUrl({ file_name: fileName });
        let file_url = fileResp.data.data.url;
        if (!file_url) throw new Error("Unable to upload file. Please try again later.");
        await ApiEndpoints.Files.uploadFileToS3(file_url, file, { headers: { "Content-Type": file.type } });
        let bannerData = {
            purpose: isCreateBanner.purpose,
            content_type: "IMAGE",
            title: isCreateBanner.title,
            poster_url: fileResp.data.data.fileUrl,
            seq_no: this.state.bannerList.length + 1,
            start_date: isCreateBanner.start_date,
            end_date: isCreateBanner.end_date,
            action: this.buildActionJSON(),
        };
        store.dispatch(setLoader(true));
        await ApiEndpoints.Marketing.createBanner(bannerData);
        await this.fetchBannerList();
        this.closeModal();
        store.dispatch(setLoader(false));
    }

    isFormValid = () => {
        let { isCreateBanner, bannerFile } = this.state;
        if (!isCreateBanner) return false;
        if (!isCreateBanner.title || !isCreateBanner.purpose) return false;
        if (!isCreateBanner.start_date || !isCreateBanner.end_date) return false;
        if (!bannerFile) return false;
        if (isCreateBanner.actionType === "LINK" && !isValidUrl(isCreateBanner.link_url || "")) return false;
        return true;
    }

    render() {
        let { isCreateBanner, bannerList, bannerPreviewUrl, jobCategoryList, showExpired, previewImageUrl } = this.state;
        const isExpired      = (b) => b.end_date && moment().isAfter(moment(b.end_date));
        const visibleBanners = showExpired ? bannerList : bannerList.filter(b => !isExpired(b));
        const expiredCount   = bannerList.filter(isExpired).length;
        const f           = isCreateBanner || {};
        const actionType  = f.actionType || "SCREEN";
        const jobList     = store.getState().jobList || [];
        const urlInvalid  = actionType === "LINK" && f.link_url && !isValidUrl(f.link_url);
        const valid       = this.isFormValid();

        return (
            <>
                {/* ── Toolbar ── */}
                <Row className="mb-3 align-items-center">
                    <Col>
                        <Button onClick={this.openModal} type="button" className="buttonred" size="sm">
                            <Icon style={{ fontSize: 15, verticalAlign: "middle", marginRight: 5 }}>add</Icon>
                            Create New Banner
                        </Button>
                    </Col>
                    <Col className="text-right" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 12 }}>
                        {expiredCount > 0 && (
                            <button
                                type="button"
                                onClick={() => this.setState({ showExpired: !showExpired })}
                                style={{
                                    background: "none", border: "1px solid #ccc", borderRadius: 6,
                                    padding: "3px 10px", fontSize: 12, cursor: "pointer",
                                    color: showExpired ? "#f1061c" : "#888",
                                    borderColor: showExpired ? "#f1061c" : "#ccc",
                                    fontWeight: showExpired ? 600 : 400,
                                }}
                            >
                                <Icon style={{ fontSize: 13, verticalAlign: "middle", marginRight: 4 }}>
                                    {showExpired ? "visibility_off" : "visibility"}
                                </Icon>
                                {showExpired ? "Hide" : "Show"} expired ({expiredCount})
                            </button>
                        )}
                        <small className="text-muted">{visibleBanners.length} banner{visibleBanners.length !== 1 ? "s" : ""} · drag to reorder</small>
                    </Col>
                </Row>

                {/* ════════════ MODAL ════════════ */}
                <Modal isOpen={!!isCreateBanner} toggle={this.closeModal} size="lg" centered>

                    {/* ── Red Header ── */}
                    <div style={{
                        background: "#f1061c", borderRadius: "6px 6px 0 0",
                        padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between",
                    }}>
                        <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>Create New Banner</span>
                        <button
                            type="button"
                            onClick={this.closeModal}
                            style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", padding: 4, lineHeight: 1 }}
                        >
                            <Icon style={{ fontSize: 20 }}>close</Icon>
                        </button>
                    </div>

                    <ModalBody style={{ padding: "24px 28px 12px" }}>
                        <form id="banner-form" onSubmit={this.createBanner}>

                            {/* Title + Purpose */}
                            <Row style={{ marginBottom: 18 }}>
                                <Col xs={6}>
                                    <label style={LABEL}>Title <span style={{ color: "#f1061c" }}>*</span></label>
                                    <InputFeild
                                        placeholder="Enter banner title"
                                        value={f.title || ""}
                                        onChange={(e) => { isCreateBanner.title = e.target.value; this.setState({ isCreateBanner }); }}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <label style={LABEL}>Purpose <span style={{ color: "#f1061c" }}>*</span></label>
                                    <InputFeild
                                        placeholder="Enter purpose"
                                        value={f.purpose || ""}
                                        onChange={(e) => { isCreateBanner.purpose = e.target.value; this.setState({ isCreateBanner }); }}
                                    />
                                </Col>
                            </Row>

                            {/* Start + End Date */}
                            <Row style={{ marginBottom: 18 }}>
                                <Col xs={6}>
                                    <label style={LABEL}>Start Date <span style={{ color: "#f1061c" }}>*</span></label>
                                    <ReactDatePicker
                                        selected={f.start_date || null}
                                        maxDate={f.end_date || null}
                                        onChange={date => { isCreateBanner.start_date = date; this.setState({ isCreateBanner }); }}
                                        isClearable
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd/mm/yyyy"
                                        className="form-control"
                                        wrapperClassName="d-block"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <label style={LABEL}>End Date <span style={{ color: "#f1061c" }}>*</span></label>
                                    <ReactDatePicker
                                        selected={f.end_date || null}
                                        minDate={f.start_date || null}
                                        onChange={date => { isCreateBanner.end_date = date; this.setState({ isCreateBanner }); }}
                                        isClearable
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd/mm/yyyy"
                                        className="form-control"
                                        wrapperClassName="d-block"
                                    />
                                </Col>
                            </Row>

                            {/* Banner Image */}
                            <div style={{ marginBottom: 18 }}>
                                <label style={LABEL}>Banner Image <span style={{ color: "#f1061c" }}>*</span></label>
                                <label
                                    htmlFor="banner-file-input"
                                    style={{
                                        display: "block", border: "2px dashed #d5d8dc", borderRadius: 8,
                                        padding: bannerPreviewUrl ? 0 : "30px 24px",
                                        textAlign: "center", cursor: "pointer",
                                        background: bannerPreviewUrl ? "transparent" : "#fdfefe",
                                        overflow: "hidden", position: "relative",
                                        transition: "border-color 0.2s",
                                    }}
                                    onMouseOver={e => e.currentTarget.style.borderColor = "#f1061c"}
                                    onMouseOut={e => e.currentTarget.style.borderColor = "#d5d8dc"}
                                >
                                    {bannerPreviewUrl ? (
                                        <>
                                            <img
                                                src={bannerPreviewUrl}
                                                alt="preview"
                                                style={{ width: "100%", maxHeight: 150, objectFit: "cover", display: "block", borderRadius: 6 }}
                                            />
                                            <div style={{
                                                position: "absolute", bottom: 0, left: 0, right: 0,
                                                background: "rgba(0,0,0,0.45)", color: "#fff",
                                                fontSize: 11, padding: "5px 0", textAlign: "center",
                                            }}>
                                                Click to replace image
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <Icon style={{ fontSize: 32, color: "#d5d8dc", display: "block", margin: "0 auto 8px" }}>cloud_upload</Icon>
                                            <div style={{ fontSize: 13, color: "#666" }}>
                                                Drag &amp; drop or{" "}
                                                <span style={{ color: "#f1061c", fontWeight: 600 }}>browse</span>{" "}
                                                to upload
                                            </div>
                                            <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>PNG, JPG, GIF supported</div>
                                        </>
                                    )}
                                    <input
                                        id="banner-file-input"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;
                                            this.setState({ bannerFile: file, bannerPreviewUrl: URL.createObjectURL(file) });
                                        }}
                                    />
                                </label>
                            </div>

                            {/* Action on banner tap */}
                            <div style={{ marginBottom: 14 }}>
                                <label style={LABEL}>Action (on banner tap)</label>

                                {/* Segmented toggle — full width, matches reference */}
                                <div style={{ display: "flex", border: "1px solid #d5d8dc", borderRadius: 6, overflow: "hidden", marginBottom: 14 }}>
                                    {[{ key: "SCREEN", label: "Select Project" }, { key: "LINK", label: "Direct URL" }].map((tab, idx, arr) => {
                                        const active = actionType === tab.key;
                                        return (
                                            <button
                                                key={tab.key}
                                                type="button"
                                                onClick={() => { isCreateBanner.actionType = tab.key; this.setState({ isCreateBanner }); }}
                                                style={{
                                                    flex: 1, padding: "10px 0", border: "none", cursor: "pointer",
                                                    fontWeight: 700, fontSize: 13,
                                                    borderRight: idx < arr.length - 1 ? "1px solid #d5d8dc" : "none",
                                                    background: active ? "#f1061c" : "#f8f9fa",
                                                    color: active ? "#fff" : "#777",
                                                    transition: "background 0.15s, color 0.15s",
                                                }}
                                            >
                                                {tab.label}
                                            </button>
                                        );
                                    })}
                                </div>

                                {/* SCREEN inputs */}
                                {actionType === "SCREEN" && (
                                    <Row>
                                        <Col xs={6}>
                                            <label style={LABEL}>Project Type</label>
                                            <Input
                                                type="select"
                                                value={f.origin_type || ""}
                                                onChange={(e) => { isCreateBanner.origin_type = e.target.value; isCreateBanner.origin_id = ""; this.setState({ isCreateBanner }); }}
                                                style={{ borderRadius: 6, fontSize: 13, height: 38 }}
                                            >
                                                <option value="" disabled>-- Select Type --</option>
                                                {ORIGIN_TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                            </Input>
                                        </Col>
                                        <Col xs={6}>
                                            {f.origin_type === "JOB_CATEGORY" && (
                                                <>
                                                    <label style={LABEL}>Job Category <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                                    <SelectList search={true} placeholder="All Categories" value={f.origin_id || ""} onChange={(e) => { isCreateBanner.origin_id = e.target.value; this.setState({ isCreateBanner }); }}>
                                                        {jobCategoryList.map(cat => (
                                                            <option key={cat.job_category_id} value={cat.job_category_id}>{cat.title}</option>
                                                        ))}
                                                    </SelectList>
                                                </>
                                            )}
                                            {f.origin_type === "JOB_TASK" && (
                                                <>
                                                    <label style={LABEL}>Job <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                                    <SelectList search={true} placeholder="All Jobs" value={f.origin_id || ""} onChange={(e) => { isCreateBanner.origin_id = e.target.value; this.setState({ isCreateBanner }); }}>
                                                        {jobList.map(job => (
                                                            <option key={job.job_id} value={job.job_id}>{job.Employer.employer_name} — {job.title}</option>
                                                        ))}
                                                    </SelectList>
                                                </>
                                            )}
                                            {f.origin_type && !["JOB_CATEGORY", "JOB_TASK"].includes(f.origin_type) && (
                                                <>
                                                    <label style={LABEL}>Origin ID <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                                    <InputFeild
                                                        placeholder="e.g. 4"
                                                        value={f.origin_id || ""}
                                                        onChange={(e) => { isCreateBanner.origin_id = e.target.value; this.setState({ isCreateBanner }); }}
                                                    />
                                                </>
                                            )}
                                        </Col>
                                    </Row>
                                )}

                                {/* LINK input */}
                                {actionType === "LINK" && (
                                    <div>
                                        <label style={LABEL}>Redirect URL <span style={{ color: "#f1061c" }}>*</span></label>
                                        <InputFeild
                                            placeholder="https://go.pickmywork.com/..."
                                            value={f.link_url || ""}
                                            onChange={(e) => { isCreateBanner.link_url = e.target.value; this.setState({ isCreateBanner }); }}
                                        />
                                        {urlInvalid && (
                                            <div style={{ fontSize: 11, color: "#f1061c", marginTop: 5 }}>
                                                <Icon style={{ fontSize: 12, verticalAlign: "middle", marginRight: 3 }}>error_outline</Icon>
                                                Must be a valid URL starting with https://
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* JSON preview */}
                            <div style={{
                                background: "#f4f6f7", border: "1px solid #e5e8e8", borderRadius: 6,
                                padding: "9px 14px", fontSize: 12, fontFamily: "monospace",
                                color: "#555", wordBreak: "break-all", marginBottom: 4,
                            }}>
                                {isCreateBanner ? this.buildActionJSON() : ""}
                            </div>

                        </form>
                    </ModalBody>

                    {/* Footer */}
                    <ModalFooter style={{ padding: "14px 28px", borderTop: "1px solid #f0f0f0", gap: 10 }}>
                        <Button
                            type="button"
                            onClick={this.closeModal}
                            style={{
                                minWidth: 90, fontSize: 13, fontWeight: 600,
                                background: "#fff", color: "#f1061c",
                                border: "1.5px solid #f1061c", borderRadius: 6,
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            form="banner-form"
                            type="submit"
                            disabled={!valid}
                            style={{
                                minWidth: 100, fontSize: 13, fontWeight: 600,
                                background: valid ? "#f1061c" : "#d4948f", border: "none",
                                color: "#fff", borderRadius: 6,
                                transition: "background 0.15s",
                            }}
                        >
                            Create
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* ════════════ BANNER LIST ════════════ */}
                {/* Table Header */}
                <div style={{
                    display: "grid", gridTemplateColumns: "40px 1fr 250px 100px 100px 50px",
                    alignItems: "center", padding: "10px 24px 10px 16px",
                    background: "#2c3e50", borderRadius: "8px 8px 0 0",
                    fontSize: 11, fontWeight: 700, letterSpacing: "0.5px",
                    textTransform: "uppercase", color: "#bdc3c7",
                }}>
                    <div>#</div>
                    <div>Banner</div>
                    <div>Image</div>
                    <div>Start</div>
                    <div>End</div>
                    <div></div>
                </div>

                {visibleBanners.length ? (
                    <div style={{ border: "1px solid #e8e8e8", borderTop: "none", borderRadius: "0 0 8px 8px", overflow: "hidden" }}>
                        {visibleBanners.map((list, i) => (
                            <div
                                key={i} id={i}
                                draggable
                                onDragOver={(ev) => ev.preventDefault()}
                                onDragStart={this.handleDragInput}
                                onDrop={this.handleDropInput}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "40px 1fr 250px 100px 100px 50px",
                                    alignItems: "center",
                                    padding: "10px 24px 10px 16px",
                                    background: i % 2 === 0 ? "#fff" : "#fafafa",
                                    borderBottom: i < visibleBanners.length - 1 ? "1px solid #f0f0f0" : "none",
                                    cursor: "grab", fontSize: 13,
                                }}
                            >
                                {/* Seq + drag handle */}
                                <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    <Icon style={{ fontSize: 14, color: "#ccc" }}>drag_indicator</Icon>
                                    <span style={{ fontSize: 11, color: "#bbb", fontWeight: 600 }}>{list.seq_no || i + 1}</span>
                                </div>

                                {/* Title (primary) + Purpose + ID (secondary) */}
                                <div style={{ paddingRight: 8 }}>
                                    <div style={{ fontWeight: 600, color: "#222", marginBottom: 2 }}>{list.title}</div>
                                    <div style={{ fontSize: 11, color: "#999" }}>{list.purpose} <span style={{ color: "#ddd" }}>·</span> <span style={{ color: "#bbb" }}>#{list.promotion_id}</span></div>
                                </div>

                                {/* Thumbnail — click to enlarge */}
                                <div>
                                    <img
                                        src={list.poster_url} alt=""
                                        title="Click to preview"
                                        onClick={() => this.setState({ previewImageUrl: list.poster_url })}
                                        style={{ width: 150, objectFit: "cover", borderRadius: 6, border: "1px solid #eee", display: "block", cursor: "zoom-in" }}
                                    />
                                </div>

                                {/* Dates */}
                                <div style={{ fontSize: 12, color: "#555" }}>{moment(list.start_date).utcOffset("+05:30").format("D MMM'YY")}</div>
                                <div style={{ fontSize: 12, color: list.end_date ? "#555" : "#aaa", fontStyle: list.end_date ? "normal" : "italic" }}>
                                    {list.end_date ? moment(list.end_date).utcOffset("+05:30").format("D MMM'YY") : "No expiry"}
                                </div>

                                {/* Delete */}
                                <div style={{ textAlign: "right" }}>
                                    <Icon
                                        title="Delete"
                                        style={{ cursor: "pointer", fontSize: 17, color: "#f1061c" }}
                                        onClick={() => this.setState({ isOpenConfirm: () => this.delete(list.promotion_id) })}
                                    >
                                        delete
                                    </Icon>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{
                        border: "1px solid #e8e8e8", borderTop: "none", borderRadius: "0 0 8px 8px",
                        padding: "50px 20px", textAlign: "center",
                    }}>
                        <Icon style={{ fontSize: 40, color: "#e0e0e0", display: "block", margin: "0 auto 10px" }}>campaign</Icon>
                        <em style={{ fontSize: 13, color: "#aaa" }}>No banners yet. Click "Create New Banner" to get started.</em>
                    </div>
                )}

                {/* ── Image lightbox ── */}
                {previewImageUrl && (
                    <div
                        onClick={() => this.setState({ previewImageUrl: null })}
                        style={{
                            position: "fixed", inset: 0, zIndex: 9999,
                            background: "rgba(0,0,0,0.78)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "zoom-out",
                        }}
                    >
                        <img
                            src={previewImageUrl} alt="Banner preview"
                            style={{ maxWidth: "90vw", maxHeight: "88vh", borderRadius: 8, boxShadow: "0 8px 40px rgba(0,0,0,0.5)" }}
                        />
                        <button
                            onClick={() => this.setState({ previewImageUrl: null })}
                            style={{
                                position: "absolute", top: 20, right: 24,
                                background: "rgba(255,255,255,0.15)", border: "none",
                                borderRadius: "50%", width: 36, height: 36,
                                color: "#fff", fontSize: 20, cursor: "pointer",
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}
                        >
                            <Icon style={{ fontSize: 20 }}>close</Icon>
                        </button>
                    </div>
                )}

                <ConfirmAction
                    isOpen={!!this.state.isOpenConfirm}
                    callback={this.state.isOpenConfirm}
                    onClose={() => this.setState({ isOpenConfirm: false, confirmMessage: null })}
                />
            </>
        );
    }
}

export default CreateBanner;
